import AdminClient from '../client/AdminClient';

class AdminUserService {
    static async index(session, params) {
        return AdminClient.get(`/v1/admin/admin_users`, session, params);
    }

    static async new(session) {
        return AdminClient.get(`/v1/admin/admin_users/new`, session);
    }

    static async create(session, params) {
        return AdminClient.post(`/v1/admin/admin_users/`, session, params);
    }

    static async update(adminUserId, session, params) {
        return AdminClient.put(`/v1/admin/admin_users/${adminUserId}`, session, params);
    }

    static async edit(adminUserId, session) {
        return AdminClient.get(`/v1/admin/admin_users/${adminUserId}/edit`, session);
    }

    static async show(adminUserId, session) {
        return AdminClient.get(`/v1/admin/admin_users/${adminUserId}`, session);
    }

    static async delete(adminUserId, session) {
        return AdminClient.delete(`/v1/admin/admin_users/${adminUserId}`, session);
    }

    static async changeLog(adminUserId, session) {
        return AdminClient.get(`/v1/admin/admin_users/${adminUserId}/change_log`, session);
    }

    static async logMapboxUsage(adminUserId, session) {
        return AdminClient.put(`/v1/admin/admin_users/${adminUserId}/log_mapbox_usage`, session);
    }

    static async uploadAvatar(adminUserId, file, session) {
        const formData = new FormData();
        formData.append('avatar', file);
        return AdminClient.uploadFile(`/v1/admin/admin_users/${adminUserId}/upload_avatar`, session, formData);
    }
}

export default AdminUserService;